import { HttpErrorResponse } from "@angular/common/http";
import { isNil } from "lodash-es";

interface Perfil {
    id: number;
    imagen: string;
    nombre: string;
    categoriaId: number;
    categoria: Categoria;
    descripcion: string;
    descripcionLarga: string;
    votos: number;
    profesion: string;
    redes: RedSocial[];
    logros: Logro[];
    periodoId: number;
    periodo: Periodo;
    finalista: boolean;
    ganador: boolean;
}
interface Periodo {
    id: number;
    periodo: number;
    habilitado: number;
    created_at?: Date;
    updated_at?: Date;
}
interface Categoria {
    id: number;
    nombre: string;
    imagen: string;
}

interface RedSocial {
    id?: number;
    nombre: string;
    link: string;
    imagen: string;
}

interface Logro {
    id?: number;
    descripcion?: string;
}

interface Parametros {
    param: string;
    valor?: string;
}

interface Usuario {
    id: number;
    name: string;
    email: string;
    remember_me_token?: boolean;
    created_at?: Date;
    updated_at?: Date;
}

interface Token {
    type: string;
    token: string;
    logueado?: boolean;
}

interface Result {
    data: any;
    message: string;
    meta?: Paginador;
}

interface LoginResult {
    usuario: Usuario;
    token: Token;
}

interface Paginador {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
    first_page: number;
    first_page_url: string;
    last_page_url: string;
    next_page_url: string;
    previous_page_url: string;
}

interface Estado {
    id: number;
    nombre: string;
    detalles: DetalleEstado[];
    createdAt: Date;
    updatedAt: Date;
}

interface DetalleEstado {
    id: number;
    estadoId: number;
    descripcion: string;
    createdAt: Date;
    updatedAt: Date;
}

interface Contacto {
    id: number;
    nombres: string;
    correo: string;
    mensaje: string;
    created_at: Date;
    updated_at: Date;
}

export function parseError(e: any | HttpErrorResponse): string {
    if (e instanceof HttpErrorResponse) {
        if (e.status === 401) {
            return e.message;
        } // unauthorized
    }
    return `${!isNil(e.response.data.message) ? e.response.data.message : JSON.stringify(e)}`;
}

export {
    Perfil,
    Categoria,
    RedSocial,
    Parametros,
    Usuario,
    Token,
    Result,
    LoginResult,
    Paginador,
    Estado,
    DetalleEstado,
    Contacto,
    Periodo,
    Logro
}

export type Method =
    | 'get' | 'GET'
    | 'delete' | 'DELETE'
    | 'post' | 'POST'
    | 'put' | 'PUT'
    | 'patch' | 'PATCH';